import { notificationsSelectors } from "./Slice";
export const allNotificationsSelector = (state) => notificationsSelectors.selectAll(state.notifications);
export const hasUnViewedNotificationSelector = (state) => notificationsSelectors
    .selectAll(state.notifications)
    .map((notification) => notification.viewed)
    .some((item) => item === false);
